<div *ngIf="products && products.length > 0">
  <section class="cart" aria-labelledby="cart-title">
    <h2 id="cart-title" class="sr-only">{{ 'components.cartProductList.srTitle' | i18n }}</h2>
    
    <div *ngIf="hasProducts">
      <ul class="cart__list" [class.category-mode]="useCategoryLayoutWhenEmpty" role="list">
         <li *ngFor="let product of products; trackBy: trackByProductId; let last = last" class="cart__item">
          <umkt-cart-product-item
            [product]="product"
            [maxQuantityByPlanId]="maxQuantityByPlanId"
            [isCartEmpty]="isCartEmpty"
            [useCategoryLayoutWhenEmpty]="useCategoryLayoutWhenEmpty"
            [showProductTerm]="showProductTerm"
            [suggestionLoadingId]="suggestionLoadingId"
            (removePlan)="onRemovePlan(product.id, $event.planId)"
            (changeQty)="onChangeQty(product.id, $event)"
            (undoRemove)="onUndoRemove(product.id, $event.planId)"
            (suggestionAccept)="suggestionAccept.emit($event)"
            (suggestionDismiss)="suggestionDismiss.emit($event)"
            [lastChild]="last"
          ></umkt-cart-product-item>
        </li>

        <li *ngIf="!isCartEmpty" class="cart__item cart__add-more">
          <a class="cart__add-hiperlink" (click)="goToMenu()">
            {{ 'components.cartProductList.addMore' | i18n }}
          </a>
        </li>
      </ul>
    </div>
  </section>
</div>